import { cn } from '@/components/ui/utils';

type BadgeVariant = 'active' | 'pending' | 'completed' | 'blocked' | 'critical';

interface BadgeProps {
  variant?: BadgeVariant;
  children: React.ReactNode;
  className?: string;
  dot?: boolean;
}

const variantStyles: Record<BadgeVariant, string> = {
  active:    'bg-[rgba(27,58,45,0.12)] text-[var(--color-forest)] border-[rgba(27,58,45,0.2)]',
  pending:   'bg-[rgba(184,150,62,0.15)] text-[var(--color-gold-dark)] border-[rgba(184,150,62,0.3)]',
  completed: 'bg-[var(--muted)] text-[var(--color-mid-gray)] border-transparent',
  blocked:   'bg-[rgba(154,41,41,0.12)] text-[var(--destructive)] border-[rgba(154,41,41,0.2)]',
  critical:  'bg-[rgba(154,41,41,0.15)] text-[var(--destructive)] border-[rgba(154,41,41,0.3)]',
};

const dotColors: Record<BadgeVariant, string> = {
  active:    'bg-[var(--color-forest)]',
  pending:   'bg-[var(--color-gold)]',
  completed: 'bg-[var(--color-mid-gray)]',
  blocked:   'bg-[var(--destructive)]',
  critical:  'bg-[var(--destructive)]',
};

export function InternBadge({ variant = 'active', children, className, dot = true }: BadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-[4px] border',
        'text-[11px] font-[500] uppercase tracking-[0.05em] leading-none',
        variantStyles[variant],
        className
      )}
    >
      {dot && (
        <span className={cn('w-1.5 h-1.5 rounded-full shrink-0', dotColors[variant])} />
      )}
      {children}
    </span>
  );
}
